module.exports = __webpack_public_path__ + "static/media/kavyasmall.117b5cc9.jpg";